
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import { getCookies } from '../../services/Utility';
import CreateForm from '../CreateForm/CreateForm';
import DashboardTable from '../dashboardTable/DashboardTable';
import PrivacyPolicy from "../privacyPolicy";
import TermsOfUse from "../termsOfUse";
import "./Dashboard.css"
import { useEffect, useState } from 'react';
import _ from 'lodash';
import Api from '../../services/Api';

const routePathAdd = [
    {
        name: "Clients",
        link: "Clients/create",
        back: "Clients",
        createUrl: "Clients",
        isLogo: false
    },
    {
        name: "Projects",
        link: "Projects/create",
        back: "Projects",
        createUrl: "projects",
        isLogo: true
    },
    {
        name: "Data Subject Types",
        link: "DataSubjectTypes/create",
        back: "DataSubjectTypes",
        createUrl: "data-subject-types",
        isLogo: false
    },
    {
        name: "Request Types",
        link: "RequestTypes/create",
        back: "RequestTypes",
        createUrl: "request-types",
        isLogo: false
    },
    {
        name: "Requests",
        link: "Requests/create",
        back: "Requests",
        createUrl: "Requests",
        isLogo: false
    },
    {
        name: "DSAR Requests",
        link: "PrivacyRequests/create",
        back: "PrivacyRequests",
        createUrl: "privacy-requests",
        isLogo: false
    },
    {
        name: "Privacy Policies",
        link: "PrivacyPolicies/create",
        back: "PrivacyPolicies",
        createUrl: "privacy-policies",
        isLogo: false
    },
    {
        name: "Terms Of Use",
        link: "TermsOfUse/create",
        back: "TermsOfUse",
        createUrl: "terms-of-use",
        isLogo: false
    },
    {
        name: "ROPA",
        link: "ROPA/create",
        back: "ROPA",
        createUrl: "ropa",
        isLogo: false
    },
    {
        name: "Tenants",
        link: "tenants/create",
        back: "tenants",
        createUrl: "tenants",
        isLogo: true
    },
    {
        name: "Users",
        link: "users/create",
        back: "users",
        createUrl: "users",
        isLogo: false
    },

]

function Dashboard() {
    const navigate = useNavigate()
    const location = useLocation()
    const isAdmin = getCookies("isAdmin");
    const [projects, setProjects] = useState([]);
    const [allProjects, setAllProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);

    const menus = [
        {
            name: "Projects",
            link: "/dashboard/Projects",
            apiLink: "projects",
            show: isAdmin === 'admin' ? true : false
        },
        {
            name: "Data Subject Types",
            link: "/dashboard/DataSubjectTypes",
            apiLink: "data-subject-types",
            show: true
        },
        {
            name: "Request Types",
            link: "/dashboard/RequestTypes",
            apiLink: "request-types",
            show: true
        },
        {
            name: "DSAR Requests",
            link: "/dashboard/PrivacyRequests",
            apiLink: "privacy-rquests",
            show: true
        },
        {
            name: "Privacy Policies",
            link: "/dashboard/PrivacyPolicies",
            apiLink: "privacy-policies",
            show: true
        },
        {
            name: "Terms Of Use",
            link: "/dashboard/TermsOfUse",
            apiLink: "terms-of-use",
            show: true
        },
        {
            name: "ROPA",
            link: "/dashboard/ROPA",
            apiLink: "ROPA",
            show: true
        },
        {
            name: "Tenants",
            link: "/dashboard/tenants",
            apiLink: "tenants",
            show: isAdmin === 'admin' ? true : false
        },
        {
            name: "Users",
            link: "/dashboard/users",
            apiLink: "users",
            show: isAdmin === 'admin' ? true : false
        },
    ]

    const routePath = [
        {
            name: "Clients",
            link: "Clients",
            create: (isAdmin && isAdmin === "admin") ? true : false,
        },
        {
            name: "Projects",
            link: "Projects",
            create: (isAdmin && isAdmin === "admin") ? true : false,
            apiLink: "projects"
        },
        {
            name: "Data Subject Types",
            link: "DataSubjectTypes",
            create: (isAdmin && isAdmin === "admin") ? true : false,
            apiLink: "data-subject-types"
        },
        {
            name: "Request Types",
            link: "RequestTypes",
            create: (isAdmin && isAdmin === "admin") ? true : false,
            apiLink: "request-types"
        },
        {
            name: "Requests",
            link: "Requests"
        },
        {
            name: "DSAR Requests",
            link: "PrivacyRequests",
            create: false,
            apiLink: "privacy-requests"
        },
        {
            name: "Privacy Policies",
            link: "PrivacyPolicies",
            create: (isAdmin && isAdmin === "admin") ? true : false,
            apiLink: "privacy-policies"
        },
        {
            name: "Terms Of Use",
            link: "TermsOfUse",
            create: (isAdmin && isAdmin === "admin") ? true : false,
            apiLink: "terms-of-use"
        },
        {
            name: "ROPA",
            link: "ROPA",
            apiLink: "ropa",
            create: true

        },
        {
            name: "Tenants",
            link: "tenants",
            create: (isAdmin && isAdmin === "admin") ? true : false,
            apiLink: "tenants"
        },
        {
            name: "Users",
            link: "users",
            create: (isAdmin && isAdmin === "admin") ? true : false,
            apiLink: "users"
        },
    ]

    useEffect(() => {
        getSelectedProject();
    }, [])

    const getSelectedProject = async () => {
        const project_id = localStorage.getItem('DP_PROJECT_ID');
        const response = await Api.getTableData('projects');

        if (project_id) {
            const selectedProject = _.find(response.data.data.results, { id: parseInt(project_id) })
            setSelectedProject(selectedProject)
        }
    }

    const renderElement = (item) => {
        const project_id = localStorage.getItem('DP_PROJECT_ID');
        if (item.link === 'PrivacyPolicies') {
            return <PrivacyPolicy apiLink={item.apiLink} />
        }
        if (item.link === 'TermsOfUse') {
            return <TermsOfUse apiLink={item.apiLink} />
        }
        return <DashboardTable
            classes={item.link}
            create={item.create}
            apiLink={item.apiLink}
            type={item.name}
            project_id={project_id !== 'undefined' ? JSON.parse(project_id) : null}
            selectedProject={selectedProject}
        />
    }

    return (
        <>
            <Navbar />
            <div className="flex">
                <div className="flex flex-col w-96 h-screen overflow-y-auto bg-[#1B3C8B]">
                    {
                        selectedProject && <div className="project_logo">
                            <img src={selectedProject.logo_url} alt="" style={{ height: '50px' }} />
                        </div>
                    }
                    <div className="flex flex-col justify-between px-4">
                        <aside>
                            <ul>
                                {localStorage.getItem('DP_PROJECT_ID') ?
                                    _.compact(menus.map(item => item.name !== 'Tenants' && item.name !== 'Projects' && item.name !== 'Users' ? <li key={item.name}>
                                        <div className={`p-2.5 mt-3 flex items-center rounded-md px-4 duration-300 cursor-pointer hover:bg-blue-600 text-white ${location.pathname === item.link ? "active-link-dashboard" : ""}`} onClick={() => navigate(item.link)} href={item.link}>
                                            <span className="mx-4 font-medium">{item.name}</span>
                                        </div>
                                    </li> : null))
                                    :
                                    menus.filter(item => item.show).map(item =>
                                        <li key={item.name}>
                                            <div className={`p-2.5 mt-3 flex items-center rounded-md px-4 duration-300 cursor-pointer hover:bg-blue-600 text-white ${location.pathname === item.link ? "active-link-dashboard" : ""}`} onClick={() => navigate(item.link)} href={item.link}>
                                                <span className="mx-4 font-medium">{item.name}</span>
                                            </div>
                                        </li>
                                    )}

                            </ul>

                        </aside>
                    </div>
                </div>
                <div className="w-full h-full p-4 m-8 overflow-y-auto dashboard-bg" style={{ height: '100vh' }}>
                    <Routes>
                        {routePath.map(item =>
                            <Route key={item.link} path={item.link}
                                element={renderElement(item)} />
                        )}
                        {routePathAdd.map(item =>
                            <Route key={item.link} path={item.link} element={<CreateForm classes={item.link} type={item.name} backLink={item.back}
                                createUrl={item.createUrl}
                                isLogo={item.isLogo}
                                selectedProject={selectedProject} />} />
                        )}

                    </Routes>
                </div>
            </div>
        </>
    );
}

export default Dashboard;